import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { AppAdsPlayerAvatarSize, getColor } from './AppAdsPlayerAvatar.model';
import { StyledPlayerAvatar } from './AppAdsPlayerAvatar.styled';

const AppAdsPlayerAvatar = ({
	nickName,
	size = AppAdsPlayerAvatarSize.Small,
}: {
	nickName: string;
	size?: AppAdsPlayerAvatarSize;
}) => {
	const playerPictureColor = useMemo(() => getColor(nickName), [nickName]);

	return (
		<StyledPlayerAvatar
			$size={size}
			style={{ backgroundColor: playerPictureColor }}
		>
			<Text>A</Text>
		</StyledPlayerAvatar>
	);
};

export { AppAdsPlayerAvatar };
